"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createApplyChain;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// 创建链式调用
// @author Pluto <huarse@gmail.com>
// @create 2019/12/30 14:17

/**
 * 创建链式调用
 * @param {Array<Function>} middlewares
 * @param {Object} [scope]
 * @return {Function}
 * @example
 * // 定义一个 middleware
 * async function logger(ctx) {
 *   console.log('before');
 *   await ctx.next();
 *   console.log('after');
 * }
 */
function createApplyChain(middlewares, scope) {
  return async function (options = {}) {
    let index = 0;
    return await _objectSpread({}, options, {
      async next(params) {
        const fn = middlewares[index++];

        if (!fn) {
          return delete this.next, this;
        }

        return await fn.call(scope, this, params), this;
      }

    }).next();
  };
}